import { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { CheckCircle2, AlertCircle, Loader2 } from "lucide-react";
import BrandLogo from "../components/BrandLogo";

export default function VerifyEmail() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [state, setState] = useState({ status: "verifying", message: "" });

  useEffect(() => {
    api.post("/orgs/email/verify", { token })
      .then(() => setState({ status: "ok", message: "Email verified. You can now invite teammates and start partnerships." }))
      .catch((e) => setState({ status: "err", message: e.response?.data?.detail || "Could not verify email." }));
  }, [token]);

  return (
    <div className="min-h-screen bg-bg text-white flex flex-col">
      <header className="px-6 py-5 border-b border-line">
        <BrandLogo variant="wordmark" size={28} />
      </header>
      <main className="flex-1 flex items-center justify-center p-6">
        <div className="surface w-full max-w-md p-10 text-center" data-testid="verify-email-result">
          {state.status === "verifying" && (
            <>
              <Loader2 className="w-8 h-8 animate-spin mx-auto text-ink-muted" />
              <div className="font-heading text-2xl uppercase mt-4">Verifying…</div>
            </>
          )}
          {state.status === "ok" && (
            <>
              <CheckCircle2 className="w-10 h-10 text-volt mx-auto" />
              <div className="font-heading text-2xl uppercase mt-4">Email verified</div>
              <p className="text-sm text-ink-muted mt-3">{state.message}</p>
              <button onClick={() => navigate("/app/brand")} className="btn-volt mt-6 text-sm" data-testid="verify-continue-btn">Continue to dashboard</button>
            </>
          )}
          {state.status === "err" && (
            <>
              <AlertCircle className="w-10 h-10 text-[#FF3B30] mx-auto" />
              <div className="font-heading text-2xl uppercase mt-4">Verification failed</div>
              <p className="text-sm text-ink-muted mt-3">{state.message}</p>
              <Link to="/" className="btn-ghost-line inline-block mt-6 text-sm">Back to PITCHD</Link>
            </>
          )}
        </div>
      </main>
    </div>
  );
}
